module.exports = __webpack_public_path__ + "static/sexual-personae-07c0d4f4543e5d7e593137e3759c667d.jpg";